import axios from 'axios'

// Supaya komponen UI tidak perlu ikut import axios cuma untuk membedakan
// "dibatalkan user" dari "gagal beneran".
export const isCancelledError = (error) => axios.isCancel(error)

// Strapi mengisi `error.message` dengan nama status HTTP-nya, jadi hampir
// selalu "Bad Request" -- tidak memberi tahu apa pun. Sebab aslinya ada di
// `error.details.info`.
const GENERIC_MESSAGES = new Set([
  'Bad Request',
  'Forbidden',
  'Internal Server Error',
  'Not Found',
  'Unauthorized',
])

// `details.info` isinya pesan error diikuti stack trace. Barisnya yang pertama
// saja yang berguna di toast; sisanya untuk console.
const firstLineOf = (info) => String(info).split('\n')[0].trim()

/**
 * Pesan yang layak ditampilkan dari sebuah error API.
 *
 * `fallback` sebaiknya menyebutkan aksi yang gagal ("Gagal menyetujui
 * pendaftaran"), karena itu satu-satunya bagian yang pasti bisa dibaca
 * pengguna kalau server tidak menjelaskan apa-apa.
 */
export const getApiErrorMessage = (
  error,
  fallback = 'Terjadi kesalahan. Silakan coba lagi.',
) => {
  const apiError = error?.response?.data?.error
  const info = apiError?.details?.info

  if (info) {
    // Trace penuh tetap perlu terbaca waktu bug ini dilaporkan.
    console.error('[api]', info)
    const detail = firstLineOf(info)
    return detail ? `${fallback} (${detail})` : fallback
  }

  const message = apiError?.message
  if (message && !GENERIC_MESSAGES.has(message)) {
    return message
  }
  return fallback
}
